


































import {Component, Vue} from 'vue-property-decorator';
import Modal from '@/shared/components/Modal.vue';
import { Action, Getter } from 'vuex-class';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import appInsights from '@/shared/services/appInsights';
import Toast from '@/shared/services/toast';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';
import { validationMixin } from 'vuelidate';
import { maxLength, required } from 'vuelidate/lib/validators';
import { CREATE_ANSWER } from '@/store/answers/actionTypes';
import { CreateAnswerViewModel } from '@/features/bots/models/answers/createAnswerViewModel';

const validFaqTitle = (value: string) => {
	return value.search(/[<>*%&:\\$]/) === -1;
};

@Component({
	mixins: [
		validationMixin
	],
	components: {
		Modal
	},
	validations: {
		faqTitle: {
			required,
			validFaqTitle,
			maxLength: maxLength(50)
		}
	}
})
export default class AddAnswerModal extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Action(CREATE_ANSWER) public createAnswer: (request: CreateAnswerViewModel) => Promise<AnswerViewModel>;
	public faqTitle: string = '';
	public isLoading: boolean = false;

	public mounted() {
		const addFaqInput: any = this.$refs.faqNameInput;
		if (addFaqInput) {
			addFaqInput.focus();
		}
	}

	public async addFAQ() {
		if (this.$v.$invalid) {
			return;
		}

		appInsights.trackEvent({ name: 'Add answer clicked' }, { workspaceId: this.currentWorkspace.id });
		this.isLoading = true;
		try {
			this.faqTitle = this.faqTitle.trim();
			const createdAnswer = await this.createAnswer({ title: this.faqTitle });
			this.isLoading = false;
			this.$emit('answer-added', createdAnswer);
			this.close();
		} catch (ex) {
			this.isLoading = false;
			if (ex.status === 409) {
				Toast.showError(`Failed to add FAQ - "${this.faqTitle}" already exists`);
			} else {
				Toast.showError('Failed to add FAQ');
			}
		}
	}

	public getErrorMessage(): string {
		if (this.$v.faqTitle.required && !this.$v.faqTitle.validFaqTitle) {
			return 'Must not contain <, >, *, %, &, :, \\, $';
		}
		if (!this.$v.faqTitle.maxLength) {
			return 'Must not be longer than 50 characters';
		}
		if (!this.$v.faqTitle.required && this.$v.faqTitle.$dirty) {
			return 'Must not be empty';
		}

		return '';
	}

	public close() {
		this.$emit('close');
	}
}
